import React, { useEffect, useState } from "react";
import "./OnboardingPage.css";

import { getCommitteesLedByUser } from "../../api/announcementsAPI";
import { getDecryptedUserId } from "../../utils/cryptoUtils";

export default function OnboardingPage() {
  const [committees, setCommittees] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => { // Database query not tested
    async function fetchCommittees() {
      // Queries database for committees using userid from login
      // Loading finalises regardless if error is present
      try {
        const userId = await getDecryptedUserId();
        if (!userId) throw new Error("User not authenticated");
        const committeeList = await getCommitteesLedByUser(userId);
        setCommittees(committeeList);
      } catch (error) {
        console.error("Error loading committees:", error.message);
        alert(`Error: Could not load committees.\n${error.message}`);
      } finally {
        setLoading(false);
      }
    }

    fetchCommittees();
  }, []);

  if (loading) {
    // Loading screen
    return <div className="obp-loading">Loading committees...</div>;
  }

  return (
    <div className="obp-container">
      <div className="obp-header">
        <div className="obp-title">Welcome to NEXUS</div>
        <div className="obp-subtitle">Please choose your committee.</div>
        <div className="obp-committees">
          {committees.length > 0 ? (
            committees.map((c) => (
              <button
                className="obp-block"
                key={c.committee_id}
                onClick={() => alert(`Selected ${c.name}`)} // Navigation still not defined
              >
                {c.name}
              </button>
            ))
          ) : (
            <div className="obp-none">No committees found.</div>
          )}
        </div>
      </div>
    </div>
  );
}

// TEST CASE to view buttons
// import React, { useEffect, useState } from "react";
// import { useNavigate } from "react-router-dom";
// import "./OnboardingPage.css";
// import { getCommitteesLedByUser } from "../../functions/addAnnouncement.mjs";

// const TEST_MODE = true; // Set to true for hardcoded testing

// const testCommittees = [
//   { committee_id: 1, name: "CSC" },
//   { committee_id: 2, name: "PACE" },
//   { committee_id: 3, name: "Queensway" },
//   { committee_id: 4, name: "Publicity" }
// ];

// export default function OnboardingPage() {
//   const navigate = useNavigate();
//   const [committees, setCommittees] = useState([]);

//   return (
//     <div className="obp-container">
//       <div className="obp-header">
//         <h1 className="obp-title">Welcome to NEXUS</h1>
//         <p className="obp-subtitle">
//           Please choose your committee.
//         </p>
//         <div className="obp-committees">
//           {testCommittees.length > 0 ? (
//             testCommittees.map((c) => (
//               <button
//                 className="obp-block"
//                 key={c.committee_id}
//                 onClick={() => alert(`Selected ${c.name}`)}
//               >
//                 {c.name}
//               </button>
//             ))
//           ) : (
//             <div className="obp-none">No committees found.</div>
//           )}
//         </div>
//       </div>
//     </div>
//   );
// }
